import { imageListFactory, ListImageElement, MewsImageProps, withMewsSrcSet } from '@optimus-web/core';

const ImageWithMewsSrc = withMewsSrcSet(ListImageElement);

const ListImageWithSizes = (props: MewsImageProps) => (
    <ImageWithMewsSrc {...props} widthSet={[144, 192, 388]} sizes="96px" />
);

export const ImageList = imageListFactory({
    Image: ListImageWithSizes,
});
